import { render, staticRenderFns } from "./SingleSignOnInput.vue?vue&type=template&id=af7f21b6"
import script from "./SingleSignOnInput.ts?vue&type=script&lang=ts&external"
export * from "./SingleSignOnInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports